//desarrollo
//const local = "http://localhost:3002";
//producción HEROKU
const produccion = "https://back-inmobiliaria-9e05d75280f8.herokuapp.com";

export const actual = produccion;